import styled from "styled-components";

export const VerticalDivider = styled.div`
  display: flex;
  height: auto;
  width: 1px;
  min-width: 1px;
  background: #D9D9D9;
`;